import React, { useState } from "react";
import { ChevronDown } from "lucide-react";
import { motion } from "framer-motion";

const faqs = [
  {
    question: "Is QuickCaptionIO free to use?",
    answer:
      "Yes! QuickCaptionIO is completely free to use. No login is required, no hidden costs, and you can start generating captions and hashtags instantly.",
  },
  {
    question: "Can I use this for any social media platform?",
    answer:
      "Absolutely! You can copy and paste captions and hashtags into Instagram, TikTok, Twitter (X), YouTube, Facebook, LinkedIn, or any platform of your choice.",
  },
  {
    question: "Do I need to create an account or sign in?",
    answer:
      "Nope! QuickCaptionIO is 100% hassle-free. You don’t need to create an account or log in. Just type your keywords and get your captions instantly.",
  },
  {
    question: "Is my data private?",
    answer:
      "Yes! Your data is never saved or shared. Everything you type stays private — we don’t store or track your inputs.",
  },
  {
    question: "How does the AI generate captions?",
    answer:
      "The AI analyzes the keywords you provide and creates engaging captions and trending hashtags based on popular social media trends. For example, typing 'Tokyo Skytree sushi first trip' could generate captions like 'Exploring Tokyo’s magic 🗼🍣 First trip, unforgettable memories!' with hashtags like #TokyoAdventures #JapanTrip #TravelVlog.",
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
      <h2 className="text-3xl md:text-4xl font-extrabold text-slate-900 dark:text-white mb-12 text-center">
        Frequently Asked Questions
      </h2>

      <div className="space-y-4">
        {faqs.map((faq, idx) => (
          <motion.div
            key={idx}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: idx * 0.1 }}
            className="bg-white dark:bg-gray-800 p-6 rounded-2xl shadow hover:shadow-lg transition"
          >
            <button
              onClick={() => toggleFAQ(idx)}
              className="w-full flex justify-between items-center text-left text-slate-900 dark:text-white font-semibold"
            >
              {faq.question}
              <ChevronDown
                className={`w-5 h-5 transition-transform duration-300 ${
                  openIndex === idx ? "rotate-180" : ""
                }`}
              />
            </button>
            {openIndex === idx && (
              <motion.p
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.3 }}
                className="mt-2 text-slate-700 dark:text-slate-300"
              >
                {faq.answer}
              </motion.p>
            )}
          </motion.div>
        ))}
      </div>
    </section>
  );
}
